import type { BoxTabsContent } from "@loot-os/design-system/templates/boxes/boxesContent";
import { useCatalogCopy } from "./copy.js";
import { useBoxesSearch } from "./search.js";

/** Which boxes the grid shows: all of them, the new ones, or the shopper's favorites. */
export function useBoxTabsContent(): BoxTabsContent {
  const copy = useCatalogCopy().tabs;
  const [search, update] = useBoxesSearch();
  return {
    value: search.tab ?? "all",
    label: copy.label,
    options: [
      { value: "all", label: copy.options.all },
      { value: "new", label: copy.options.new },
      { value: "favorites", label: copy.options.favorites },
    ],
    onValueChange: (tab) => update({ tab: tab === "all" ? undefined : tab }),
  };
}
